const getMRVPrintTemplate = (data) => {

  const formatDateDMY = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const reportData = data?.items || [];

// ✅ ADD THIS LINE (FIX)
const firstItem = reportData?.[0] || {};

  return `
<html>
<head>
<meta charset="utf-8"/>
<title>MRV</title>
</head>

<body style="background-color:#f7fafc; padding:16px;">
<div style="max-width:1024px; margin:0 auto; background:white; padding:24px; box-shadow:0 4px 6px rgba(0,0,0,0.1);">

<!-- HEADER -->
<div style="margin-bottom:16px;">

  <div style="display:flex; justify-content:space-between; align-items:flex-start;">
    <div>
      <h1 style="font-size:1.25rem; font-weight:bold; margin:0;">
        Indigo Infraprojects Pvt. Ltd.
      </h1>
      <p style="font-size:0.85rem; margin:2px 0;">
        3rd Floor, Plot No. - 12/B, Pocket 3, Sector - 17
      </p>
      <p style="font-size:0.85rem; margin:2px 0;">
        Dwarka, New Delhi - 110075
      </p>
    </div>

    <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" width="110"/>
  </div>

  <div style="text-align:center; margin-top:10px;">
    <h2 style="font-weight:bold; text-transform:uppercase;">
      Material Receipt Voucher (Digital Copy)
    </h2>
  </div>
</div>

<!-- DETAILS -->
<div style="display:flex; justify-content:space-between; margin-bottom:16px; font-size:14px;">
  <div>
    <p>MRV No : <strong>${data.mrvNo || "-"}</strong></p>
    <p>Supplier : ${data.supplier?.name || "-"}</p>
    <p>Bill No : ${data.billingNo || "-"}</p>
    <p>Bill Date : ${formatDateDMY(data.billingDate)}</p>
    <p>Status : <strong>${data.status || "-"}</strong></p>
  </div>

  <div>
    <p>Project Code : ${data.store?.storeCode || "-"}</p>
    <p>Project Name : ${data.store?.name || "-"}</p>
    <p>Date : <strong>${formatDateDMY(data.createdAt)}</strong></p>
  </div>
</div>

<!-- TABLE -->
<table style="width:100%; border-collapse:collapse; border:1px solid #cbd5e0;">
<thead>
<tr>
  <th style="border:1px solid #cbd5e0; padding:8px;">S.No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Part No</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Description</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Unit</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Req Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Appr Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Received Qty</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Damage Qty</th> <!-- ✅ NEW -->
    <th style="border:1px solid #cbd5e0; padding:8px;">PO</th>
  <th style="border:1px solid #cbd5e0; padding:8px;">Status</th>
</tr>
</thead>

<tbody>
${reportData && reportData.length > 0
      ? reportData.map((item, i) => `
<tr>
  <td style="border:1px solid #cbd5e0; padding:8px;">${i + 1}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.partNo || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.description || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.unit || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.qtyRequired || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.approveQty || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.qtyRecived || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.damageQty || 0}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.poNumber || "-"}</td>
  <td style="border:1px solid #cbd5e0; padding:8px;">${item?.status || "-"}</td>
</tr>
`).join("")
      : `
<tr>
  <td colspan="9" style="border:1px solid #cbd5e0; padding:10px; text-align:center;">
    No Items Found
  </td>
</tr>
`
    }
</tbody>
</table>

<!-- FOOTER -->
<div style="margin-top:32px; font-size:14px;">
  <div style="display:flex; justify-content:space-between;">

    <div style="width:33%;">
      <p>Prepared By</p>
      <strong>${data.user?.name?.toUpperCase() || "________"}</strong>
      <p>Date : ${formatDateDMY(data.createdAt)}</p>
    </div>

    <div style="width:33%; text-align:center;">
      <p>Approved By</p>
      <strong>${firstItem.approvedByAdmin?.toUpperCase() || "________"}</strong>
      <p>(Project Manager)</p>
    </div>

    <div style="width:33%; text-align:right;">
      <p>Approved By</p>
      <strong>${firstItem.approvedBySuperAdmin?.toUpperCase() || "________"}</strong>
      <p>(Central Team)</p>
    </div>

  </div>
</div>

</div>
</body>
</html>
`;
};

export default getMRVPrintTemplate;